import { useFeatures, type WorkspaceFeatures } from "@expert/features";

import { useIsPacingActive } from "./useIsPacingActive";

/**
 * Gates the VCP 1.5 "Glow Bar" visual. Deliberately a strict subset of {@link useIsPacingActive}, so the
 * analytics gate (`isPacingEnabled`) and metrics like "On-target call pace" are unaffected.
 *
 * V2 is required because the glow bar needs the full-width call-bar row only that layout provides.
 * The legacy topbar is a fixed 56px inside a ScrollArea, which flattens the bar's radius and border
 * and clips the exceeded glow. Without V2 the expert falls back to the current pill.
 */
export function useIsGlowBarPacingActive(): boolean {
    const isPacingActive = useIsPacingActive();
    const {
        features: { isGlowBarPacingEnabled, isVoiceWorkspaceRedesignV2Enabled },
    } = useFeatures<WorkspaceFeatures>();

    return isPacingActive && Boolean(isGlowBarPacingEnabled) && Boolean(isVoiceWorkspaceRedesignV2Enabled);
}
